export const manifest = {
  screens: {
    scr_hr98qq: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_ct06mt: { name: "Department — CSE", route: "/department/cse", position: {"x":160,"y":2200} },
    scr_6r0sh9: { name: "Faculty — Research Graph", route: "/faculty/profile", state: {"activeTab":"Research Graph"}, position: {"x":160,"y":4180} },
    scr_sla5cx: { name: "Faculty — Biography", route: "/faculty/profile", state: {"activeTab":"Biography & Education"}, position: {"x":1560,"y":4180} },
    scr_rilaiv: { name: "Faculty — Publications", route: "/faculty/profile", state: {"activeTab":"Publications & Journals"}, position: {"x":2960,"y":4180} },
    scr_vpoovk: { name: "CV Generator", route: "/faculty/cv-generator", position: {"x":4360,"y":4180} },
    scr_5v15lf: { name: "Programming Club", route: "/clubs/programming", position: {"x":160,"y":6160} },
    scr_yasmx7: { name: "Academic Calendar", route: "/academic-calendar", position: {"x":160,"y":8140} },
  },
  sections: {
    sec_6p5gkw: { name: "Home", x: 0, y: 0, width: 1520, height: 1180 },
    sec_8i641g: { name: "Academic Structure", x: 0, y: 1980, width: 1520, height: 1180 },
    sec_0ei76e: { name: "Faculty Profile", x: 0, y: 3960, width: 5720, height: 1180 },
    sec_avf3kg: { name: "Student Organizations", x: 0, y: 5940, width: 1527, height: 1224 },
    sec_l7xdc1: { name: "Resources", x: 0, y: 7920, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_6p5gkw", children: [
      { kind: "screen", id: "scr_hr98qq" },
    ] },
    { kind: "section", id: "sec_8i641g", children: [
      { kind: "screen", id: "scr_ct06mt" },
    ] },
    { kind: "section", id: "sec_0ei76e", children: [
      { kind: "screen", id: "scr_6r0sh9" },
      { kind: "screen", id: "scr_sla5cx" },
      { kind: "screen", id: "scr_rilaiv" },
      { kind: "screen", id: "scr_vpoovk" },
    ] },
    { kind: "section", id: "sec_avf3kg", children: [
      { kind: "screen", id: "scr_5v15lf" },
    ] },
    { kind: "section", id: "sec_l7xdc1", children: [
      { kind: "screen", id: "scr_yasmx7" },
    ] },
  ],
}
